import { ValueOf } from './util';

export const campaignAggregationCriterias = {
  DAILY: '日次',
  MONTHLY: '月次',
  YEARLY: '年次',
  WALLET_SERVICE: 'ウォレットサービス別',
  COMPANY: '企業別',
  SHOP: '店舗別',
  CAMPAIGN: '管理名称',
} as const;

export type CampaignAggregationCriteriaKey = keyof typeof campaignAggregationCriterias;
export type CampaignAggregationCriteriaValue = ValueOf<typeof campaignAggregationCriterias>;

export const campaignAggregationCriteriaKeys = Object
  .keys(campaignAggregationCriterias) as CampaignAggregationCriteriaKey[];

/** v-select用items */
export const campaignAggregationCriteriaItems = campaignAggregationCriteriaKeys
  .map((key) => ({
    title: campaignAggregationCriterias[key],
    value: key,
  }));
